import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { normalizeToArray } from '../../../util/utils';

function handleStackAnimation(group: any[]) {
  const ANIMATION_DURATION = 1000;
  const PER_ANIMATION_DURATION = ANIMATION_DURATION / group.length;
  group.forEach((item, index) => {
    item.animationDuration = PER_ANIMATION_DURATION;
    item.animationEasing = 'linear';
    item.animationDelay = PER_ANIMATION_DURATION * index;
  });
}

function handleStacksAnimation(barSeries: any[]) {
  const stacks = barSeries.reduce((prev: Array<Array<any>>, cur) => {
    if (prev.length === 0) {
      prev.push([]);
    }
    const arr: Array<any> = prev[prev.length - 1];
    if (arr.length === 0) {
      arr.push(cur);
    } else {
      const prevStack = arr[arr.length - 1].stack as string;
      if (prevStack === cur.stack) {
        arr.push(cur);
      } else {
        prev.push([cur]);
      }
    }
    return prev;
  }, []);
  stacks.forEach(handleStackAnimation);
}

export function install(registers: EChartsExtensionInstallRegisters) {
  // * ecModel.setOption() 时
  registers.registerPreprocessor(option => {
    const barSeries = normalizeToArray<any>(option.series).filter(el => el.stack);
    handleStacksAnimation(barSeries);
  });
}
